<template>
  <div v-if="rsvpPending || rsvpLoading">
    <v-progress-linear indeterminate />
  </div>

  <div v-else>
    <v-layout row align-baseline v-if="rsvp">
      <v-flex xs2>
        <v-chip label outline color="blue">
          My RSVP
        </v-chip>
      </v-flex>
      <v-flex xs10>
        <v-layout row align-baseline justify-start>
          <v-flex shrink>
            <span v-if="responded" class="cursor-pointer">
              <v-chip outline small color="success" v-if="attending">
                GOING
              </v-chip>
              <v-chip outline small color="error" v-if="!attending">
                NOT GOING
              </v-chip>
            </span>
            <span v-else>
              <v-chip outline small slot="activator" style="cursor: pointer;">
                Haven't responded
              </v-chip>
            </span>
          </v-flex>

          <v-flex shrink class="ml-2" v-if="!responded">
            <v-btn @click="respond(true)" :loading="rsvpPending" text flat color="success">
              Going
            </v-btn>
            <v-btn @click="respond(false)" :loading="rsvpPending" text flat color="error">
              Not Going
            </v-btn>
          </v-flex>

          <v-flex shrink class="ml-2" v-else>
            <div v-if="showChange">
              <v-btn v-if="!attending" @click="respond(true)" :loading="rsvpPending" text flat color="success">
                Going
              </v-btn>
              <v-btn v-if="attending" @click="respond(false)" :loading="rsvpPending" text flat color="error">
                Not Going
              </v-btn>
              <a class="text-decoration-underline" @click="showChange = !showChange">
                Hide
              </a>
            </div>
            <div v-else>
              <a class="text-decoration-underline" style="cursor: pointer;" @click="showChange = !showChange">
                Change RSVP
              </a>
            </div>
          </v-flex>

        </v-layout>
        <v-layout v-if="lastResponded">
          <span class="caption subtle">Last updated {{ lastResponded | moment("MMMM DD h:mma") }}</span>
        </v-layout>

      </v-flex>
    </v-layout>

    <v-layout row align-baseline v-else>
      You're not on the guest list for this event
    </v-layout>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import invitesApi from '@/api/invites';

export default {
  props: [ 'eventId' ],
  components: { },
  created () {
    this.fetchMyRSVP(this.eventId)
  },
  data: function () {
    return {
      attending: null,
      responded: null,
      rsvpLoading: false,
      rsvp: null,
      rsvpPending: false,
      showChange: false,
      lastResponded: null,
    }
  },

  methods: {
    fetchMyRSVP(eventId) {
      this.rsvpLoading = true
      invitesApi.rsvpForEvent(eventId, rsvp => {
        this.rsvp = rsvp
        this.attending = rsvp.attending
        this.responded = rsvp.responded
        this.lastResponded = rsvp.last_responded_at
        this.rsvpLoading = false
      })
    },

    respond(response) {
      this.rsvpPending = true
      invitesApi.respond(
        { eventId: this.eventId, going: response }
      ).then((rsvp) => {
        this.rsvpPending = false
        this.responded = rsvp.responded
        this.attending = rsvp.attending
        this.lastResponded = rsvp.last_responded_at
      })
    },
  },
}
</script>
